// PrimeNG removes an overlay mask (drawer/dialog/menu backdrop) on the mask's own CSS
// animationend. When something else lands in the same frames as an overlay's ~300ms leave
// animation (a route change resolving near-instantly offline, another overlay opening/closing
// right on top of it, etc.), the browser can cancel the animation before its end event fires,
// and PrimeNG never removes the mask. The orphan is an invisible full-screen div at a high
// z-index that swallows every tap (the page still scrolls, since touch-drag passes through to
// the document behind a fixed, non-scrollable element). Originally diagnosed live via Chrome
// DevTools Protocol against a frozen WebView: hit-testing showed a stray
// `.p-drawer-mask.p-overlay-mask-leave-active` covering the viewport with Angular fully stable
// underneath — see AppComponent's NavigationEnd-triggered sweep, which only covers the
// close-then-navigate case. Call this from any other overlay's own close handler too (the
// sidebar drawer's onHide(), for one) so "close without navigating" is covered as well.
//
// 800ms is comfortably past any overlay's leave animation; anything still in leave-active
// state by then is orphaned and must go. A mask from an overlay the user has since reopened is
// in enter/steady state, not leave-active, so it is never touched.
export function scheduleOrphanedOverlayMaskSweep(): void {
  setTimeout(() => {
    document.querySelectorAll('.p-overlay-mask-leave-active').forEach((el) => el.remove());
  }, 800);
}
